/* @ngInject */
function HomeTasksController ($scope, $q, HomeService, SegmentService, UdsModalService, TasksService) {
  const getRequestDetailsDialogController = () => $q.when(import('../../../workflow/dialogs/request-details/request-details-dialog.controller'))
  const getSubtaskDetailsDialogController = () => $q.when(import('../../../workflow/dialogs/subtask-details/subtask-details-dialog.controller'))
  const getCreateTaskDialogController = () => $q.when(import('../../../workflow/dialogs/create-task/create-task-dialog.controller'))

  const api = {
    getRequestDetailsDialogController,
    getSubtaskDetailsDialogController,
    getCreateTaskDialogController,
    _handleSuccessGetTasks,
    _handleSuccessCountTasks,
    _openSubtaskDetailsDialog,
    _openRequestDetailsDialog,
    _openNewTask
  }
  this.getApi = () => api

  activate()

  function activate () {
    HomeService.getTasks(3).then(api._handleSuccessGetTasks)
    HomeService.countTasks().then(api._handleSuccessCountTasks)
  }

  const deregisterReopenCreateTaskDialog = $scope.$on('workflow.reopenCreateTaskDialog', (event, data) => {
    api._openNewTask(data?.createMore)
  })

  $scope.$on('$destroy', () => {
    deregisterReopenCreateTaskDialog()
  })

  function _handleSuccessGetTasks (tasks) {
    $scope.tasks = tasks
  }

  function _handleSuccessCountTasks (count) {
    $scope.countAll = count
  }

  $scope.openNewTask = api._openNewTask

  $scope.openTaskDetails = function (task) {
    if (task.originType === 'SUBTASK') {
      TasksService.getTaskById(task.id).then(subtask => {
        api._openSubtaskDetailsDialog(subtask)
      })
    } else {
      api._openRequestDetailsDialog(task.id)
    }

    SegmentService.track('workflow-widget-view')
  }

  function _openNewTask (createMore = false) {
    function _onSuccess (created) {
      if (created) {
        HomeService.countTasks().then(api._handleSuccessCountTasks)
        SegmentService.track('workflow-widget-new')
      }
    }

    api.getCreateTaskDialogController().then(({ CreateTaskDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: CreateTaskDialogController,
        modalName: 'createTaskDialogDirective',
        data: { createMore },
        onClose: _onSuccess
      })

      modal.open()
    })
  }

  function _openSubtaskDetailsDialog (subtask) {
    api.getSubtaskDetailsDialogController().then(({ SubtaskDetailsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: SubtaskDetailsDialogController,
        modalName: 'subtaskDetailsDialog',
        data: {
          subtask
        }
      })
      modal.open()
    })
  }

  function _openRequestDetailsDialog (id) {
    api.getRequestDetailsDialogController().then(({ RequestDetailsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: RequestDetailsDialogController,
        modalName: 'requestDetailsDialog',
        data: {
          id
        }
      })
      modal.open()
    })
  }
}

export { HomeTasksController }
